import { Mouvement, type LigneMouvement } from '@mairistem/comptabilite';
import {
  every, isEmpty, isNaN, isNil,
} from 'lodash';
import type { ErrorField } from '@mairistem/liste';
import BaseProfilEcritureMouvement from './BaseProfilEcritureMouvement';

class BaseProfilRattachement extends BaseProfilEcritureMouvement {
  naturePieceOrigine = '';

  exerRattachement = '';

  idLigneOriginePes: number;

  idPieceOrigine: number;

  getLigneDefaultAttributes(): object {
    return {
      naturePieceOrigine: this.naturePieceOrigine,
      exerRattachement: this.exerRattachement,
      idLigneOriginePes: this.idLigneOriginePes,
      idPieceOrigine: this.idPieceOrigine,
    };
  }

  onProfilSelect(data: Partial<Mouvement>) {
    return {
      ...super.onProfilSelect(data),
      // Si les lignes n'ont pas déjà les informations
      ...((!isNil(data.lignes) && (!every(data?.lignes, this.getLigneDefaultAttributes())
        || every(this.getLigneDefaultAttributes(), (attributes) => isEmpty(attributes))))
        && {
          lignes: data?.lignes?.map((ligne) => ({
            ...ligne,
            ...this.getLigneDefaultAttributes(),
          })),
        }
      ),
    };
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (ligne.exerRattachement.length !== 4 || isNaN(Number(ligne.exerRattachement))) {
      errors.push({
        id: `ligneMouvement-exerRattachement-${ligne?.identifiant}`,
        message: "L'exercice de rattachement doit être une année valide (4 chiffres)",
      });
    }

    return errors;
  }
}

export default BaseProfilRattachement;
